import React, { useEffect, useState, useRef } from "react";
import "./DashboardVariableFormModal.css"
import DashboardVariableCondition from "./DashboardVariableCondition";
import IconButton from '/src/components/UI/Button/IconButton/IconButton';
import generateKey from '/src/utils/generateKey';
const DashboardBlockVariableCondition = ({ block, hookBlocks }) => {

    const { getConditionsByBlock, createCondition, getVariables } = hookBlocks

    var conditions = getConditionsByBlock(block.index);
    useEffect(() => {
        if (!conditions || conditions.length == 0) {
            createCondition(block.index);
        }
    }, [conditions])

    return (
        <div className="container_block_condition_dashboard" key={generateKey()}>
            <>
                {
                    conditions != null && conditions.length > 0 ?
                        <>
                            {
                                conditions.map((cond, i) => {
                                    return (
                                        <div key={generateKey()}>
                                            {i != 0 && <div style={{ textAlign: "center", color: "var(--main)" }}> OR </div>}
                                            <DashboardVariableCondition condition={cond} hookBlocks={hookBlocks} block={block} variables={getVariables()} key={generateKey()} />
                                        </div>
                                    )
                                })
                            }
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <IconButton id={block.index + "add_conditionnal_button"} className="main-iconButton add-hover modalButtons-input" icon="fas fa-plus-circle" onClick={() => createCondition(block.index)} />
                            </div>
                        </>

                        :

                        <div style={{ display: 'flex', justifyContent: "center" }}>
                            <IconButton id={block.index + "add_conditionnal_button"} className="main-iconButton add-hover modalButtons-input" icon="fas fa-plus-circle" onClick={() => createCondition(block.index)} />
                        </div>

                }
            </>
        </div >
    )
}
export default DashboardBlockVariableCondition